import { CompanyStaffView } from "../../category-views";
import { JobPostingsPage } from "@/features/job-postings";
import type { ReactNode } from "react";
import { DEFAULT_VIEW_TYPE } from "../../../constants";

interface TabViewProps {
  categoryId?: string | number;
  tabId?: string | number;
}

export const TAB_VIEW_REGISTRY: Record<
  string,
  (props: TabViewProps) => ReactNode
> = {
  "company-staff": () => <CompanyStaffView />,
  "job-postings": () => <JobPostingsPage />,
};

export function getTabView(
  viewType: string,
  props?: TabViewProps,
): ReactNode | null {
  if (viewType === DEFAULT_VIEW_TYPE || !viewType) {
    return null;
  }

  const ViewComponent = TAB_VIEW_REGISTRY[viewType];
  if (!ViewComponent) {
    return null;
  }

  return ViewComponent(props || {});
}
